import React from 'react';
import { Button, Container } from 'react-bootstrap';
import Icofont from 'react-icofont';
import styled from 'styled-components';

import { Caption } from 'components/ui/Caption';
import { DiamondSeparator } from 'components/ui/Separators';

const ContactContainer = styled.div`
    background-color: var(--primary-blue);
    padding-top: 80px;
    padding-bottom: 60px;

    h2 {
        color: white;
    }

    a {
        text-decoration: none;

        transition: all 100ms;
    }

    a:hover {
        filter: brightness(0.9);
    }

    #whatsapp-button {
        background-color: #25d366 !important;

        :hover {
            filter: brightness(1.2);

            transition: filter 0.2s ease-in-out;
        }
    }
`;

function ContactSection(): JSX.Element {
    return (
        <ContactContainer id="contact">
            <Container>
                <Caption>
                    <h2>
                        <strong>Contáctate</strong> con Nosotros
                    </h2>

                    <DiamondSeparator color="white" />

                    <div className="text-white w-50 mx-auto ps-lg-4">
                        <div className="d-flex justify-content-start align-items-center">
                            <Icofont icon="email" size="2" />
                            <a
                                href="mailto:gruponoral@hotmail.com"
                                className="text-white ms-2"
                            >
                                gruponoral@hotmail.com
                            </a>
                        </div>
                        <div className="d-flex justify-content-start align-items-center mt-2">
                            <Icofont icon="brand-whatsapp" size="2" />
                            <span className="text-white ms-2">904415911</span>
                        </div>
                        <div className="d-flex justify-content-start align-items-center mt-2">
                            <Icofont icon="facebook" size="2" />
                            <a
                                href="https://www.facebook.com/Grupo-Noral-124130986253403"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white ms-2"
                            >
                                Grupo Noral
                            </a>
                        </div>
                    </div>
                    <div className="w-50 mx-auto">
                        <Button
                            id="whatsapp-button"
                            type="submit"
                            className="mt-4 w-100"
                            variant="primary"
                            href={`https://wa.me/51904415911?text=${encodeURIComponent(
                                'Hola, me gustaría adquirir un libro',
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Comunicarse por Whatsapp
                        </Button>
                    </div>
                </Caption>
            </Container>
        </ContactContainer>
    );
}

export default ContactSection;
